{
  "accountSettings.planDeleteDialog.header": "是否确定要删除此计划？",
  "accountSettings.planDeleteDialog.content": "删除之后，该计划将无法再次使用。",
  "accountSettings.header.text": "创建计划",
  "accountSettings.header.tooltip": "您在账户中创建的第一个忠诚度计划是您的缺省计划。未与其他计划关联的新成员将自动添加到缺省计划。",
  "accountSettings.input.planName.label": "计划名称",
  "accountSettings.input.planName.tooltip": "输入唯一的品牌计划名称，以帮助您推销您的忠诚度计划。计划名称将在钱包中可见。",
  "accountSettings.input.planIdentifier.label": "计划标识符（计划标识）",
  "accountSettings.input.planIdentifier.tooltip": "创建永久标识，用于内部识别计划。计划启动后，标识无法更改。标识必须是字母数字，并且只能是小写字符。",
  "accountSettings.input.planType.label": "计划类型",
  "accountSettings.input.planType.tooltip": "启动忠诚度计划后，您只能在基于积分的计划之间切换。您不能在基于积分和基于消费的计划之间切换。",
  "accountSettings.btn.AddNewPlan.tooltip": "添加计划以管理不同类型会员的多个忠诚度计划。",
  "accountSettings.btn.AddNewPlan.disabled.tooltip": "要创建新的忠诚度计划，请联系 SAP Emarsys 支持 {text}",
  "accountSettings.notification.content.learnMoreLinkText": "了解更多",
  "accountSettings.notification.content": "设置您的忠诚度计划结构和类型。启动计划后，您无法更改计划标识符。{learnMoreLink}。",
  "accountSettings.notification.content.firstPlan": "创建您的忠诚度计划。您可以在忠诚度账户设置中添加计划。{learnMoreLink}。",
  "cashbackSettings.notification.content": "启用现金返还计划以将现金返还计划纳入您的忠诚度计划。在忠诚度优惠券中管理现金返还池。您可以在计划处于活动状态后启用现金返还。 ",
  "cashbackSettings.cashbackEnabled.cb.tooltip": "启用现金返还计划并定义现金返还设置。",
  "cashbackSettings.cashbackEnabled.cb.label": "现金返还",
  "cashbackSettings.cashbackName.input.label": "现金返还名称",
  "cashbackSettings.cashbackName.input.tooltip": "现金返还名称用于显示 Loyalty Wallet 中的总现金返还。 ",
  "cashbackSettings.cashbackName.input.placeholder": "现金返还",
  "cashbackSettings.cashbackLimit.rb.label": "年度现金返还限额",
  "cashbackSettings.cashbackLimit.rb.tooltip": "选择是否要限制会员可赚取的年度现金返还金额。",
  "cashbackSettings.cashbackLimit.rb.option.limited": "限制年度现金返还",
  "cashbackSettings.cashbackLimit.rb.option.unlimited": "无限制现金返还",
  "cashbackSettings.cashbackLimitValue.input.label": "最高现金返还总额",
  "cashbackSettings.resetAt.label": "年度重置日期",
  "cashbackSettings.resetAt.tooltip.unlimited": "即使您设置了无限制现金返还，您仍然可以选择希望年度现金返还总额重置并重新开始计算的日期。",
  "cashbackSettings.resetAt.tooltip.limited": "选择希望年度现金返还总额重置并重新开始计算的日期。",
  "languageAndCurrency.deleteDialog.header.language": "是否确定要删除此语言？",
  "languageAndCurrency.deleteDialog.content.language": "删除此语言后，将删除语言设置，您的计划将不再支持此语言。",
  "languageAndCurrency.deleteDialog.header.currency": "是否确定要删除此货币？",
  "languageAndCurrency.deleteDialog.content.currency": "删除此货币后，将删除货币设置，您的计划将不再支持此货币。",
  "languageAndCurrency.deleteDialog.header.market": "是否确定要删除此市场？",
  "languageAndCurrency.deleteDialog.content.market": "删除此市场后，将删除市场设置，您的计划将不再支持此市场。",
  "languageAndCurrency.languageSelect.label": "选择语言",
  "languageAndCurrency.languageSelect.placeholder": "-- 选择语言 --",
  "languageAndCurrency.storeUrl.label": "门店 URL",
  "languageAndCurrency.storeUrl.placeholder": "http://storename@domain.com",
  "languageAndCurrency.storeUrl.tooltip": "定义所选语言的门店网站 URL。在所有必填的设置字段中会自动预设该 URL。",
  "languageAndCurrency.currencySelect.label": "选择货币",
  "languageAndCurrency.currencySelect.placeholder": "-- 选择货币 --",
  "languageAndCurrency.marketSelect.label": "选择市场",
  "languageAndCurrency.marketSelect.placeholder": "-- 选择市场 --",
  "languageAndCurrency.notification.learnMoreLinkText": "了解更多",
  "languageAndCurrency.notification.marketsLinkText": "市场",
  "languageAndCurrency.notification": "定义您的忠诚度计划将支持的语言、货币和 {marketsLink} 。 {learnMoreLink}",
  "languageAndCurrency.primaryLanguage.title": "主要语言",
  "languageAndCurrency.primaryLanguage.tooltip": "主要语言是您的忠诚度账户中显示的缺省语言，供没有关联语言的会员使用。",
  "languageAndCurrency.additionalLanguage.title": "附加语言",
  "languageAndCurrency.additionalLanguage.addButtonText": "添加语言",
  "languageAndCurrency.primaryCurrency.title": "主要货币",
  "languageAndCurrency.primaryCurrency.tooltip": "主要货币是您的忠诚度账户中显示的缺省货币，供没有关联货币的会员使用。",
  "languageAndCurrency.additionalCurrency.title": "附加货币",
  "languageAndCurrency.additionalCurrency.addButtonText": "添加货币",
  "languageAndCurrency.primaryMarket.title": "主要市场",
  "languageAndCurrency.primaryMarket.tooltip": "市场可以是国家、地区或任何其他类别，只要您可以在自己的网站上创建此类别即可。市场可让您通过选择相关市场来定位忠诚度优惠。",
  "languageAndCurrency.additionalMarket.title": "附加市场",
  "languageAndCurrency.additionalMarket.addButtonText": "添加市场",
  "membershipSettings.calculationPeriodTooltip.points": "选择要使用多少过去数据来计算用户层级和积分。这根据会员加入忠诚度计划时开始的定义期限计算。",
  "membershipSettings.calculationPeriodTooltip.spend": "该期限定义要使用多少过去数据来计算从会员加入忠诚度计划时开始的新会员分配和初始业绩余额。 ",
  "membershipSettings.notification.learnMoreLinkText": "了解更多",
  "membershipSettings.notification": "定义加入您的忠诚度计划的联系人会发生什么，他们是否应该获得之前购买的积分以及在什么时期获得积分。这些设置不适用于迁移的联系人。{learnMoreLink}。",
  "membershipSettings.title": "会员设置",
  "membershipSettings.contactDistributionRb.label": "新会员分配",
  "membershipSettings.contactDistributionRb.tooltip": "选择当新会员加入您的忠诚度计划时，您希望如何按层级分配会员。",
  "membershipSettings.contactDistributionRb.options.firstTier.name": "将新会员添加到第一层级。",
  "membershipSettings.contactDistributionRb.options.firstTier.tooltip": "使用此选项使所有新忠诚度会员从第一层级开始。",
  "membershipSettings.contactDistributionRb.options.tierByPeriod.name": "根据新会员在定义的计算期间内的消费历史记录，将新会员添加到层级。",
  "membershipSettings.contactDistributionRb.options.tierByPeriod.tooltip": "使用此选项根据用户加入前的消费情况，激励他们加入忠诚度计划。",
  "membershipSettings.pointsDistribution.title": "积分分配",
  "membershipSettings.pointsDistribution.tooltip": "选择当新会员加入您的忠诚度计划时，您希望如何向他们分配积分。",
  "membershipSettings.pointsDistribution.statusPoints.title": "添加状态积分",
  "membershipSettings.pointsDistribution.statusPoints.tooltip": "根据新会员在选定计算期间内的消费历史记录，向新会员提供新层级的状态积分。",
  "membershipSettings.pointsDistribution.balancePoints.title": "添加消费积分",
  "membershipSettings.pointsDistribution.balancePoints.tooltip": "根据新会员在选定计算期间内的消费历史记录，向新会员提供新层级的消费积分。",
  "membershipSettings.pointsDistribution.creditBalance.title": "添加历史业绩余额",
  "membershipSettings.pointsDistribution.creditBalance.tooltip": "根据新会员在选定计算期间内的消费历史记录，向新会员提供新层级的初始业绩余额。",
  "membershipSettings.calculationPeriodRb.title": "计算期间",
  "membershipSettings.calculationPeriodRb.options.beginOfYear.name": "使用今年年初的所有数据。",
  "membershipSettings.calculationPeriodRb.options.byPeriod.name": "将数据限制为先前：",
  "planSettings.notification.learnMoreLinkText": "了解更多",
  "planSettings.notification": "定义忠诚度计划设置。启动计划后，您无法编辑层级和状态积分计算。{learnMoreLink}。",
  "updateAndLaunch.launchConfirmationDialog.headline": "是否确定要启动新的忠诚度计划？",
  "updateAndLaunch.launchConfirmationDialog.content": "启动新计划后，新计划将替换您当前的计划。",
  "updateAndLaunch.launchConfirmationDialog.label": "启动计划",
  "updateAndLaunch.notification.beforeFirstLaunch.title": "您目前正在创建您的忠诚度计划 {planName}/{planId}。",
  "updateAndLaunch.notification.beforeFirstLaunch.content": "您的忠诚度计划设置已保存。该计划在您启动后生效。",
  "updateAndLaunch.notification.showCurrentVersion.title": "您的忠诚度计划 {planName}/{planId} 现已生效，无法编辑。",
  "updateAndLaunch.notification.showCurrentVersion.content": "最新启动： ",
  "updateAndLaunch.notification.editing.title": "您正在编辑您的忠诚度计划 {planName}/{planId} 下一版本。",
  "updateAndLaunch.notification.editing.content": "忠诚度计划中的更改在您启动计划后生效。",
  "updateAndLaunch.selectVersionMode.title": "选择版本模式",
  "updateAndLaunch.selectVersionMode.options.editNext.name": "编辑下一版本",
  "updateAndLaunch.selectVersionMode.options.liveVersion.name": "实时版本",
  "updateAndLaunch.launchPlanBtn.label": "启动计划",
  "updateAndLaunch.missingSettings.title": "检查您的计划设置是否完整。",
  "updateAndLaunch.missingSettings.content": "要启动此计划，请检查以下设置：{missingSettings}",
  "updateAndLaunch.missingSettings.invalidTier": "层级设置",
  "updateAndLaunch.missingSettings.joinDefaultInvalid": "您必须先设置缺省加入操作，然后才能启动计划",
  "updateAndLaunch.missingSettings.purchaseDefaultInvalid": "您必须先设置缺省购买操作，然后才能启动计划。",
  "updateAndLaunch.missingSettings.noSalesData": "销售数据",
  "updateAndLaunch.missingSettings.learnMore": "了解更多",
  "updateAndLaunch.errors.invalidTier": "您必须在“层级设置”中完成层级设置，然后才能启动您的计划。 ",
  "updateAndLaunch.errors.joinDefaultInvalid": "您的缺省加入操作处于非活动状态。",
  "updateAndLaunch.errors.purchaseDefaultInvalid": "您的缺省购买操作处于非活动状态。",
  "updateAndLaunch.errors.noSalesData": "您必须在启动此计划之前完成数据配置。请联系 SAP Emarsys 支持寻求帮助。",
  "updateAndLaunch.planLaunchStatus.label": "您的计划正在启动，可能需要几个小时。您可以继续处理计划的实时版本。",
  "updateAndLaunch.title": "更新和启动",
  "updateAndLaunch.content.beforeFirstLaunch": "您的计划启动后，将切换到实时版本模式。要编辑并重新启动您的计划，请切换到编辑版本模式。",
  "updateAndLaunch.content.afterEdit.learnMoreLinkText": "了解更多",
  "updateAndLaunch.content.afterEdit": "要编辑并重新启动您的计划，请切换到编辑版本模式。在您编辑下一个版本时，实时版本仍处于活动状态。当您启动新计划时，新版本将替换实时计划。{learnMoreLinkText}",
  "updateAndLaunch.warning.smartInsightsLinkText": "Smart Insight",
  "updateAndLaunch.warning.smartInsights": "您必须先完成 {link} 设置，然后才能启动您的计划。",
  "onboarding.activationAlert": "您的忠诚度计划入职已成功完成。",
  "onboarding.title": "忠诚度入职",
  "planSettingsCalculationSettings.status": "状态 ",
  "planSettingsCalculationSettings.title": "计算设置",
  "planSettingsCalculationSettings.tiersCalculationType.label": "层级计算时间范围",
  "planSettingsCalculationSettings.tiersCalculationType.tooltip.points": "选择您希望多久计算一次此层级状态的累积状态积分。启动计划后，要编辑此设置，请联系 SAP Emarsys 支持 {linkToCustomerSupport}。",
  "planSettingsCalculationSettings.tiersCalculationType.tooltip.spend": "选择您希望多久计算一次此层级状态的累积消费业绩。启动计划后，若要编辑此设置，请联系 SAP Emarsys 支持 {linkToCustomerSupport}",
  "planSettingsCalculationSettings.tiersCalculationYearlyInterval.label": "层级过期",
  "planSettingsCalculationSettings.tiersCalculationYearlyInterval.tooltip": "选择您希望层级状态重置并重新开始计算的频率（年）。若要编辑此设置，请联系 SAP Emarsys 支持 {linkToCustomerSupport}。",
  "planSettingsCalculationSettings.tiersCalculationYearlyInterval.prefix": "年",
  "planSettingsCalculationSettings.tiersCalculationStartYear.label": "第一层级计算",
  "planSettingsCalculationSettings.tiersCalculationMonthlyInterval.label": "层级过期",
  "planSettingsCalculationSettings.tiersCalculationMonthlyInterval.tooltip": "选择您希望层级状态重置并重新开始计算的频率（月）。若要编辑此设置，请联系 SAP Emarsys 支持 {linkToCustomerSupport}。",
  "planSettingsCalculationSettings.statusPointsExpirationType.label.points": "状态积分过期",
  "planSettingsCalculationSettings.statusPointsExpirationType.label.spend": "忠诚度积分过期",
  "planSettingsCalculationSettings.statusPointsExpirationType.tooltip.points": "选择状态积分何时过期并重置。要在启动计划后编辑此设置，请联系 SAP 支持 {linkToCustomerSupport}",
  "planSettingsCalculationSettings.statusPointsExpirationType.tooltip.spend": "选择忠诚度积分何时过期并重置。首次启动后无法编辑此设置。要编辑，请联系 {linkToCustomerSupport}",
  "planSettingsCalculationSettings.statusPointsValidity.duration.label.points": "状态积分有效期",
  "planSettingsCalculationSettings.statusPointsValidity.duration.label.spend": "忠诚度积分有效期",
  "planSettingsCalculationSettings.statusPointsValidity.duration.tooltip.points": "从会员获得积分之日起定义状态积分有效期。",
  "planSettingsCalculationSettings.statusPointsValidity.duration.tooltip.spend": "从会员获得业绩之日起定义忠诚度业绩有效期。",
  "planSettingsCalculationSettings.statusPointsValidity.duration.prefix": "月",
  "planSettingsCalculationSettings.balancePointsExpiration.label": "消费积分过期",
  "planSettingsCalculationSettings.balancePointsExpiration.tooltip": "要限制积分有效期，请选择您希望消费积分何时过期并从会员余额中移除。",
  "planSettingsCalculationSettings.pointsAboutToExpire.duration.label": "积分即将过期",
  "planSettingsCalculationSettings.pointsAboutToExpire.duration.tooltip": "选择在消费积分过期前多久将其添加到即将过期的消费积分中。",
  "planSettingsCalculationSettings.historicalBalancePoints.label": "余额积分历史记录",
  "planSettingsCalculationSettings.historicalBalancePoints.tooltip": "选择是否要根据会员加入忠诚度计划时的忠诚度活动奖励他们赚取的消费积分。当您重新启动计划时，此操作会完成一次。 ",
  "planSettingsCalculationSettings.pointsAboutToExpire.duration.postfix": "天",
  "planSettingsGeneral.title": "计划设置",
  "planSettingsGeneral.name.label": "计划名称",
  "planSettingsGeneral.name.tooltip": "输入唯一的品牌计划名称，以帮助您推销您的忠诚度计划。计划名称将在钱包中可见。",
  "planSettingsGeneral.planType.label": "计划类型",
  "planSettingsGeneral.planType.tooltip": "首次启动计划后，您只能在基于积分的计划之间切换。您不能在基于积分和基于消费的计划之间切换。",
  "planSettingsGeneral.pointsName": "积分名称",
  "planSettingsGeneral.singlePointName": "单一积分名称",
  "planSettingsGeneral.loyaltyCreditName": "忠诚度业绩名称",
  "planSettingsGeneral.pointsName.tooltip": "积分是忠诚度计划中的货币。您可以根据自己的喜好为其命名和标记（例如，星星、积分、硬币），以便会员在钱包、奖励和固定福利中看到。货币以忠诚度账户中的积分进行管理。 ",
  "planSettingsGeneral.pointsName.spend.tooltip": "忠诚度积分显示会员在忠诚度钱包中的消费余额。它包括会员获得的附加积分，并根据定义的计划和层级设置进行计算。",
  "planSettingsGeneral.pointsName.spend.placeholder": "业绩",
  "planSettingsGeneral.currencyIdentifierSign.label": "货币标识符",
  "planSettingsGeneral.currencyIdentifierSign.tooltip": "定义货币标识符以及消费余额（包括附加积分）在会员忠诚度钱包中的显示方式。",
  "planSettingsGeneral.rewardsAllocationDelay.duration.label": "奖励分配延迟",
  "planSettingsGeneral.rewardsAllocationDelay.duration.tooltip": "选择购买奖励后多久添加到会员账户。",
  "planSettingsGeneral.rewardsAllocationDelay.duration.placeholder": "输入天数",
  "planSettingsGeneral.multiLangPopup.errorNotification": "字段是所有语言的必填项。",
  "onBoardingActivation.header": "激活您的忠诚度账户",
  "onBoardingActivation.content": "您可以在启动计划之前编辑忠诚度计划设置。",
  "onBoardingActivation.activateBtn.label": "激活",
  "onBoardingActivation.content.title": "下一步",
  "onBoardingActivation.content.line1": "设置层级",
  "onBoardingActivation.content.line2": "设置操作",
  "onBoardingActivation.content.line3": "创建奖励池",
  "onBoardingActivation.content.line14": "启动计划",
  "onBoardingSelectPlan.title": "选择您的忠诚度计划",
  "onBoardingSelectPlan.content": "为您的会员选择您喜欢的忠诚度计划。所有计划都可以增加忠诚客户、购买和参与。",
  "onBoardingSelectPlan.readmap.title": "路线图",
  "onBoardingSelectPlan.points": "积分",
  "onBoardingSelectPlan.spend": "消费",
  "onBoardingSelectPlan.subscription": "订阅",
  "onBoardingSelectPlan.notice": "* 计划选择仅进行一次，无法更改。",
  "salesDataSettings.currency.tooltip": "选择您要用于忠诚度计算的货币。货币在 Smart Insight 常规设置中定义。",
  "salesDataSettings.markets.label": "选择市场",
  "salesDataSettings.markets.tooltip": "选择与所选货币相关且与忠诚度计划相关的市场。显示的市场从您的销售数据中导入。",
  "salesDataSettings.priceField.label": "购买字段",
  "salesDataSettings.priceField.tooltip": "根据您选择的字段授予购买或活动积分。字段在 Smart Insight 设置的购买字段下定义。",
  "salesDataSettings.currency.addNewBtn.label": "添加货币",
  "accountSettingsValidator.planName.presence": "输入计划名称。",
  "accountSettingsValidator.planId.presence": "输入计划标识符。",
  "accountSettingsValidator.planId.format": "仅使用小写字母 a-z 和数字 0-9 输入计划标识符。",
  "accountSettingsValidator.planId.exclusionIgnoreCase": "此计划标识符已被使用。输入唯一计划标识符。",
  "accountSettingsValidator.planType.presence": "输入计划类型。",
  "accountSettingsValidator.priceField.presence": "输入购买字段。",
  "accountSettingsValidator.priceField.currency.presence": "输入货币。",
  "accountSettingsValidator.priceField.markets.presence": "输入市场。",
  "languageAndCurrencyValidator.language.presence": "输入语言。",
  "languageAndCurrencyValidator.currency.presence": "输入货币名称。",
  "languageAndCurrencyValidator.storeUrl.url": "输入有效的门店网站 URL。",
  "balancePointsExpiration.duration.presence": "输入余额积分过期时间。",
  "balancePointsExpiration.duration.numericality.notInteger": "输入大于零的余额积分过期时间。",
  "balancePointsExpiration.duration.numericality.notGreaterThan": "输入大于零的余额积分过期时间。",
  "planSettingsConstraints.planType.presence": "输入计划类型。",
  "planSettingsConstraints.planSettings.name.presence": "输入计划名称。",
  "planSettingsConstraints.planSettings.nameMultiLanguage.presence": "计划名称是所有语言的必填项。",
  "planSettingsConstraints.planSettings.pointsName.presence": "请输入 12 个或更少字符的积分名称。",
  "planSettingsConstraints.planSettings.pointsNameMultiLanguage.presence": "积分名称是所有语言的必填项。",
  "planSettingsConstraints.planSettings.pointsName.length": "请输入 12 个或更少字符的积分名称。",
  "planSettingsConstraints.planSettings.balancePointsExpiration.duration.messageRequired": "输入余额积分过期时间。",
  "planSettingsConstraints.planSettings.balancePointsExpiration.duration.messageHigherThanZero": "输入大于零的余额积分过期时间。",
  "planSettingsConstraints.planSettings.rewardsAllocationDelay.duration.presence": "输入奖励分配延迟。",
  "planSettingsConstraints.planSettings.rewardsAllocationDelay.duration.numericality.notInteger": "输入等于或大于零的奖励分配延迟。",
  "planSettingsConstraints.planSettings.statusPointsExpirationType.presence": "输入状态积分过期时间。",
  "planSettingsConstraints.planSettings.rules.tiersCalculationYearlyInterval.presence": "输入层级过期时间。",
  "planSettingsConstraints.planSettings.rules.tiersCalculationYearlyInterval.numericality.notInteger": "输入大于零的层级过期时间。",
  "planSettingsConstraints.planSettings.rules.tiersCalculationYearlyInterval.numericality.notGreaterThan": "输入大于零的层级过期时间。",
  "planSettingsConstraints.planSettings.rules.statusPointsValidity.duration.presence": "输入状态积分过期时间。",
  "planSettingsConstraints.planSettings.rules.statusPointsValidity.duration.numericality.notInteger": "输入大于零的状态积分过期时间。",
  "planSettingsConstraints.planSettings.rules.statusPointsValidity.duration.numericality.notGreaterThan": "输入大于零的状态积分过期时间。",
  "planSettingsConstraints.planSettings.rules.historicalBalancePoints.presence": "输入历史余额积分。",
  "planSettingsConstraints.planSettings.rules.pointsAboutToExpire.duration.presence": "输入即将过期的积分。",
  "planSettingsConstraints.planSettings.rules.pointsAboutToExpire.duration.numericality.notInteger": "输入大于零的即将过期的积分。",
  "planSettingsConstraints.planSettings.rules.pointsAboutToExpire.duration.numericality.notGreaterThan": "输入大于零的即将过期的积分。",
  "planSettingsConstraints.planSettings.rules.pointsAboutToExpire.duration.numericality.notLessThan": "输入即将过期的积分，值不能高于积分过期时间 ({duration} {timeUnit})。",
  "planSettingsConstraints.planSettings.spendPlan.pointsName.presence": "请输入 12 个或更少字符的忠诚度业绩名称。",
  "planSettingsConstraints.planSettings.spendPlan.pointsNameMultiLanguage.presence": "忠诚度业绩名称是所有语言的必填项。",
  "planSettingsConstraints.planSettings.spendPlan.pointsName.length": "请输入 12 个或更少字符的忠诚度业绩名称。",
  "planSettingsConstraints.planSettings.spendPlan.currencyIdentifierSign.presence": "输入货币标识符",
  "planSettingsConstraints.planSettings.singlePointName.length": "请输入 12 个或更少字符的单个积分名称。",
  "planSettingsConstraints.planSettings.singlePointName.presence": "请输入 12 个或更少字符的单个积分名称。",
  "planSettingsConstraints.planSettings.singlePointNameMultiLanguage.presence": "单个积分名称是所有语言的必填项。",
  "planSettingsConstraints.planSettings.contactDistributionCalcType.presence": "输入计算期间。",
  "planSettingsConstraints.planSettings.contactDistributionCalcPeriod.presence": "输入计算期间",
  "planSettingsConstraints.planSettings.contactDistributionCalcPeriod.numericality.notInteger": "输入大于零的计算时间。",
  "planSettingsConstraints.planSettings.contactDistributionCalcPeriod.numericality.notGreaterThan": "输入大于零的计算时间。",
  "planSettingsConstraints.planSettings.cashbackName.presence": "请输入 12 个或更少字符的现金返还名称。",
  "planSettingsConstraints.planSettings.cashbackName.length": "请输入 12 个或更少字符的现金返还名称。",
  "planSettingsConstraints.cashback.maxAmount.presence": "输入大于零的最大累计金额。",
  "planSettingsConstraints.cashback.maxAmount.numericality.notGreaterThan": "输入大于零的最大累计金额。",
  "planSettingsConstraints.cashback.resetAt.day.presence": "输入年度重置日期。",
  "priceField.options.price": "如果您正在使用一种货币，请使用此选项。",
  "priceField.options.originalPrice": "如果您正在使用多种货币，请使用此选项。",
  "walletConfig.sections.CommonSettings": "通用设置",
  "walletConfig.sections.EarnPage": "赚取页面",
  "walletConfig.sections.JoinPage": "加入页面",
  "walletConfig.sections.MyActivity": "我的活动",
  "walletConfig.sections.RedeemPage": "兑换页面",
  "walletConfig.sections.VoucherSettings": "优惠券设置",
  "walletConfig.sections.WelcomePage": "欢迎页面",
  "walletConfig.sections.CancelMemebership": "取消会员资格",
  "walletConfig.sections.RemoveVoucher": "移除优惠券",
  "walletConfig.sections.RemoveAccess": "移除访问权限",
  "walletConfig.groups.additionalSettings": "附加设置",
  "walletConfig.commonSettings.groups.colors": "颜色",
  "walletConfig.commonSettings.groups.font": "字体",
  "walletConfig.commonSettings.groups.generalSettings": "常规设置",
  "walletConfig.commonSettings.fontFace.label": "字体",
  "walletConfig.commonSettings.fontFace.uploadButton": "上载",
  "walletConfig.commonSettings.primaryColor.label": "主要背景颜色",
  "walletConfig.commonSettings.secondaryColor.label": "次要背景颜色",
  "walletConfig.commonSettings.primaryFontColor.label": "字体颜色",
  "walletConfig.commonSettings.showMobile.label": "在客户钱包上显示手机",
  "walletConfig.commonSettings.joinGuests.label": "向未登录用户显示钱包",
  "walletConfig.commonSettings.hasHowItWorks.label": "激活工作原理",
  "walletConfig.commonSettings.hideCancelMembership.label": "隐藏取消会员资格",
  "walletConfig.commonSettings.walletHomePage.label": "钱包主页",
  "walletConfig.commonSettings.walletHomePage.redeem": "兑换",
  "walletConfig.commonSettings.walletHomePage.reward": "奖励",
  "walletConfig.joinPage.groups.button": "按钮",
  "walletConfig.joinPage.buttonSingleColor.label": "按钮 - 单色",
  "walletConfig.joinPage.buttonPosition.comment": "在右侧面板中选择移动版和桌面版的按钮位置。",
  "walletConfig.joinPage.isButtonClosedMobile.label": "按钮在移动版中关闭",
  "walletConfig.joinPage.buttonJoinWidth.label": "按钮连接宽度 (px)",
  "walletConfig.textFields.placeholder": "在此处键入文本",
  "walletConfig.joinPage.buttonJoinWidthMobile.label": "移动版按钮连接宽度 (px)",
  "walletConfig.welcomePage.groups.logo": "徽标",
  "walletConfig.welcomePage.groups.urlLinks": "URL 链接",
  "walletConfig.welcomePage.groups.additionalSettings": "附加设置",
  "walletConfig.welcomePage.logoFileName.label": "标签在此处",
  "walletConfig.welcomePage.linkLogin.label": "链接登录",
  "walletConfig.welcomePage.linkRegister.label": "链接注册",
  "walletConfig.welcomePage.linkTerms.label": "链接条款",
  "walletConfig.welcomePage.afterJoinLandingPageURL.label": "加入链接后的登录页面",
  "walletConfig.earnPage.groups.earnGroupOrder": "获得团购订单",
  "walletConfig.earnPage.showTimeOnActions.label": "显示操作时间",
  "walletConfig.redeemPage.groups.rewardGroupsOrder": "兑换团购订单",
  "walletConfig.redeemPage.showTimeOnVouchers.label": "显示优惠券时间",
  "walletConfig.myActivity.groups.headerValues": "标题值",
  "walletConfig.myActivity.groups.additionalSettings": "附加设置",
  "walletConfig.myActivity.headerValues.label": "选择并重新排列单元格以进行排序",
  "walletConfig.myActivity.headerValues.comment": "从上到下的单元格对应于钱包标题中从左到右的值。",
  "walletConfig.myActivity.hideTiersBar.label": "隐藏层级栏",
  "walletConfig.myActivity.headerValue.cashback.label": "现金返还积分",
  "walletConfig.myActivity.headerValue.empty.label": "空",
  "walletConfig.myActivity.headerValue.pendingCashback.label": "待处理现金返还",
  "walletConfig.myActivity.headerValue.expiresSoon.label": "即将过期",
  "walletConfig.myActivity.headerValue.pendingPoints.label": "待处理",
  "walletConfig.myActivity.headerValue.pointsToSpend.label": "消费积分",
  "walletConfig.myActivity.headerValue.statusPoints.label": "状态积分",
  "walletConfig.myActivity.headerValue.position.left": "左",
  "walletConfig.myActivity.headerValue.position.middle": "中间",
  "walletConfig.myActivity.headerValue.position.right": "右",
  "walletConfig.voucherSettings.groups.voucher": "优惠券",
  "walletConfig.voucherSettings.hideVoucherCode.label": "隐藏优惠券代码",
  "walletConfig.voucherSettings.linkCart.label": "链接购物车",
  "walletConfig.multiLangPopupTitle": "基于语言的 URL"
}
